var _path, _g, _path2, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _path11, _g10, _path12, _g11, _path13, _path14, _g12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinalAuditReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 148,
    y: 67,
    width: 36,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.766 95.9039L149.718 88.0969C149.908 86.5736 151.146 85.1454 153.431 83.8601C162.809 78.6713 172.234 73.4825 181.612 68.2936C182.041 68.0556 182.469 67.8176 183.04 67.4844L182.088 75.2914C181.517 75.6246 181.089 75.8627 180.66 76.1007C171.282 81.2895 161.857 86.4784 152.479 91.6672C150.194 92.9525 148.956 94.3806 148.766 95.9039Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.045 67.5391L182.093 75.3461C181.522 75.6793 181.093 75.9174 180.665 76.1554C171.287 81.3442 161.861 86.533 152.483 91.7219C152.15 91.9123 151.864 92.1027 151.531 92.2931L152.483 84.4861C152.769 84.2957 153.102 84.1052 153.435 83.9148C162.813 78.726 172.239 73.5372 181.617 68.3483C182.045 68.1103 182.474 67.8723 183.045 67.5391Z",
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.494 84.4844L151.542 92.2914C151.066 92.6247 150.638 92.9103 150.305 93.2435L151.257 85.4365C151.59 85.1032 152.018 84.77 152.494 84.4844Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.244 85.4453L150.292 93.2524C150.007 93.4904 149.769 93.776 149.578 94.014L150.53 86.207C150.721 85.969 150.959 85.6833 151.244 85.4453Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.537 86.2031L149.585 94.0102C149.394 94.2482 149.251 94.4386 149.156 94.6766L150.108 86.8696C150.204 86.6316 150.394 86.4411 150.537 86.2031Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.105 86.8594L149.153 94.6664C149.058 94.8568 148.962 95.0949 148.867 95.3329L149.819 87.5258C149.914 87.2878 150.01 87.0974 150.105 86.8594Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.821 87.5312L148.869 95.3383C148.822 95.5287 148.774 95.7191 148.727 95.9572L149.679 88.1501C149.726 87.9121 149.774 87.7217 149.821 87.5312Z",
    fill: "#949494"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.051 72.9688C192.098 84.9649 193.145 97.1039 194.193 109.195C183.387 102.721 172.342 96.1043 161.203 89.4397C171.248 83.8701 181.292 78.348 191.051 72.9688Z",
    fill: "#ADADAD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 160,
    y: 89,
    width: 35,
    height: 28
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M194.184 109.162L193.232 116.969C182.426 110.495 171.382 103.878 160.242 97.2133L161.194 89.4062C172.334 96.1184 183.425 102.735 194.184 109.162Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.184 109.162L193.232 116.969C182.426 110.495 171.382 103.878 160.242 97.2133L161.194 89.4062C172.334 96.1184 183.425 102.735 194.184 109.162Z",
    fill: "#858585"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 88,
    width: 18,
    height: 19
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8869 98.6453L72.9348 106.452C67.3176 103.072 61.7479 99.7878 56.2734 96.4555L57.2255 88.6484C62.7476 91.9807 68.2696 95.313 73.8869 98.6453Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8869 98.6453L72.9348 106.452C67.3176 103.072 61.7479 99.7878 56.2734 96.4555L57.2255 88.6484C62.7476 91.9807 68.2696 95.313 73.8869 98.6453Z",
    fill: "#858585"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 95,
    width: 19,
    height: 19
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.418 105.309L113.466 113.116C107.896 109.783 102.374 106.499 96.8047 103.166L97.7568 95.3594C103.326 98.6917 108.848 101.976 114.418 105.309Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.418 105.309L113.466 113.116C107.896 109.783 102.374 106.499 96.8047 103.166L97.7568 95.3594C103.326 98.6917 108.848 101.976 114.418 105.309Z",
    fill: "#858585"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 185,
    y: 113,
    width: 2,
    height: 9
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186.986 113.664L186.034 121.471C185.701 121.662 185.511 121.804 185.32 121.9L186.272 114.092C186.51 113.997 186.653 113.902 186.986 113.664Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.986 113.664L186.034 121.471C185.701 121.662 185.511 121.804 185.32 121.9L186.272 114.092C186.51 113.997 186.653 113.902 186.986 113.664Z",
    fill: "#ADADAD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 137,
    y: 102,
    width: 18,
    height: 18
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.949 112.052L153.997 119.859C148.428 116.526 142.906 113.242 137.336 109.862L138.288 102.055C143.858 105.387 149.38 108.719 154.949 112.052Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.949 112.052L153.997 119.859C148.428 116.526 142.906 113.242 137.336 109.862L138.288 102.055C143.858 105.387 149.38 108.719 154.949 112.052Z",
    fill: "#858585"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 88,
    width: 25,
    height: 22
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2451 88.6797L56.293 96.4867C48.6764 100.676 41.1074 104.865 33.5859 109.007L34.538 101.2C42.0594 97.058 49.6285 92.8688 57.2451 88.6797Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2451 88.6797L56.293 96.4867C48.6764 100.676 41.1074 104.865 33.5859 109.007L34.538 101.2C42.0594 97.058 49.6285 92.8688 57.2451 88.6797Z",
    fill: "#ADADAD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 98,
    width: 4,
    height: 14
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01791 106.729L6.96999 98.9219C6.82717 100.255 7.49363 101.683 9.01696 103.254C9.11216 103.349 9.11216 103.444 9.15977 103.539L8.20769 111.347C8.16008 111.251 8.16008 111.156 8.06488 111.061C6.58915 109.49 5.8751 108.062 6.01791 106.729Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16073 103.586L8.20865 111.393C8.16105 111.298 8.16105 111.203 8.06584 111.108C6.54251 109.537 5.87606 108.061 6.01887 106.776L6.97095 98.9688C6.82814 100.302 7.49459 101.73 9.01792 103.301C9.11313 103.396 9.11313 103.491 9.16073 103.586Z",
    fill: "#858585"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 95,
    width: 40,
    height: 30
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.744 95.3594L96.7919 103.166C84.0817 110.164 71.4666 117.114 58.8516 124.065L59.8036 116.258C72.3711 109.355 85.0337 102.405 97.744 95.3594Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.744 95.3594L96.7919 103.166C84.0817 110.164 71.4666 117.114 58.8516 124.065L59.8036 116.258C72.3711 109.355 85.0337 102.405 97.744 95.3594Z",
    fill: "#ADADAD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 102,
    width: 55,
    height: 38
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.212 102.055L137.26 109.862C119.456 119.668 101.747 129.427 84.0859 139.186L85.038 131.379C102.747 121.62 120.408 111.861 138.212 102.055Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.212 102.055L137.26 109.862C119.456 119.668 101.747 129.427 84.0859 139.186L85.038 131.379C102.747 121.62 120.408 111.861 138.212 102.055Z",
    fill: "#ADADAD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 103,
    width: 89,
    height: 61
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4609 155.823L95.5088 163.63C66.4228 146.207 37.3367 128.784 8.20312 111.409L9.1552 103.602C38.2412 121.025 67.3748 138.4 96.4609 155.823Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.4609 155.823L95.5088 163.63C66.4228 146.207 37.3367 128.784 8.20312 111.409L9.1552 103.602C38.2412 121.025 67.3748 138.4 96.4609 155.823Z",
    fill: "#858585"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M186.324 114.134C161.094 128.034 135.864 141.935 110.634 155.835C107.635 157.501 102.684 157.692 98.3996 156.406C97.7332 156.216 97.1143 156.026 96.4479 155.835C67.3619 138.365 38.2282 120.989 9.14222 103.566C9.09462 103.471 9.09462 103.376 8.99941 103.28C5.80994 99.9481 6.28598 97.2823 10.4751 94.9973C45.6545 75.5749 80.8338 56.2001 116.013 36.8253C120.964 34.1119 127.628 34.4451 133.055 37.6822C149.241 47.3458 165.426 57.0094 181.564 66.7206C182.04 67.0062 182.516 67.2918 183.039 67.625C182.468 67.9583 182.04 68.1963 181.611 68.4343C172.233 73.6231 162.808 78.812 153.43 84.0008C148.146 86.9046 148.479 90.713 154.334 94.2357C164.712 100.472 175.09 106.66 185.515 112.896C186.039 113.182 186.515 113.515 187.038 113.801C186.657 113.896 186.515 113.991 186.324 114.134ZM101.732 141.316C119.488 131.51 137.197 121.798 154.906 111.992C149.336 108.66 143.814 105.375 138.244 101.995C120.44 111.802 102.732 121.56 85.0705 131.319C90.6878 134.747 96.2099 138.031 101.732 141.316ZM76.4542 126.226C89.1645 119.228 101.732 112.278 114.395 105.327C108.825 101.995 103.303 98.7104 97.7332 95.3782C85.0229 102.376 72.4079 109.326 59.7928 116.276C65.4101 119.609 70.9322 122.941 76.4542 126.226ZM51.1765 111.135C58.7455 106.946 66.267 102.804 73.8836 98.6152C68.2663 95.2353 62.6967 91.9507 57.2222 88.6184C49.6056 92.8075 42.0366 96.9967 34.5151 101.138C40.1324 104.518 45.6068 107.85 51.1765 111.135Z",
    fill: "#ADADAD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_6202_9352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 114,
    width: 92,
    height: 52
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M186.321 114.125L185.368 121.932C160.138 135.832 134.908 149.733 109.678 163.633C106.679 165.299 101.728 165.49 97.444 164.204C96.7775 164.014 96.1586 163.824 95.4922 163.633L96.4443 155.826C97.1107 156.016 97.7296 156.207 98.396 156.397C102.633 157.683 107.631 157.492 110.63 155.826C135.86 141.926 161.09 128.025 186.321 114.125Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_6202_9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.324 114.125L185.372 121.932C160.142 135.832 134.912 149.733 109.682 163.633C109.348 163.824 108.967 164.014 108.539 164.157L109.491 156.35C109.92 156.207 110.3 156.016 110.634 155.826C135.864 141.926 161.094 128.025 186.324 114.125Z",
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.495 156.359L108.543 164.166C107.829 164.452 107.067 164.642 106.258 164.785L107.21 156.978C108.019 156.835 108.781 156.597 109.495 156.359Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.209 156.977L106.257 164.784C105.447 164.926 104.638 165.022 103.781 165.022L104.733 157.215C105.543 157.215 106.399 157.119 107.209 156.977Z",
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.681 157.211L103.729 165.018C103.205 165.018 102.634 165.018 102.062 165.018L103.015 157.211C103.586 157.211 104.157 157.211 104.681 157.211Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.067 157.213L102.115 165.02C101.639 164.973 101.163 164.973 100.734 164.877L101.686 157.07C102.115 157.118 102.591 157.166 103.067 157.213Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.636 157.073L100.684 164.88C100.255 164.833 99.8269 164.737 99.3984 164.69L100.351 156.883C100.779 156.93 101.207 157.026 101.636 157.073Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.393 156.864L99.4408 164.671C99.0124 164.576 98.6316 164.48 98.2031 164.385L99.1552 156.578C99.536 156.673 99.9645 156.769 100.393 156.864Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1577 156.598L98.2056 164.405C97.9676 164.357 97.682 164.262 97.444 164.214C96.7775 164.024 96.1586 163.833 95.4922 163.643L96.4443 155.836C97.1107 156.026 97.7296 156.217 98.396 156.407C98.6341 156.455 98.9197 156.55 99.1577 156.598Z",
    fill: "#949494"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalAuditReport);
export default __webpack_public_path__ + "static/media/final-audit-report.dc00c88b6edce4094b4e5b2a2d4ff8e9.svg";
export { ForwardRef as ReactComponent };